import { useMemo } from 'react';

import { useFormContext, useWatch } from 'react-hook-form';

import { TemplateStudioModel } from 'common/contracts';
import { z } from 'zod';

import { buyOneGetManyDesigns } from 'components/TemplatesStudio/DesignsMetadata/buyOneGetMany.metadata';
import { RollingOffersDesignsMetadata } from 'components/TemplatesStudio/DesignsMetadata/types';

import { templateStudioSchema } from '../../../validation-schema';
import { DesignSidebarItem } from '../Components/DesignSidebarItem';

const BUY_ONE_GET_MANY_OBJECT_PATH = 'buyOneGetMany';

const getBuyOneGetManyDesignsByFilter = ({
  desktopLayout,
  themes
}: {
  desktopLayout: NonNullable<
    TemplateStudioModel['buyOneGetMany']
  >['desktopLayout'];
  themes: NonNullable<TemplateStudioModel['buyOneGetMany']>['themes'];
}): RollingOffersDesignsMetadata[] => {
  return Object.values(buyOneGetManyDesigns).filter((currentDesign) => {
    const matchesLayout = currentDesign.layout.includes(desktopLayout);
    const matchesTheme =
      !themes || themes.length === 0 || themes.includes(currentDesign.theme);
    return matchesLayout && matchesTheme;
  });
};

export const BuyOneGetManyDesignsSecondarySidebar: React.FC = () => {
  const { control } = useFormContext<z.infer<typeof templateStudioSchema>>();

  const buyOneGetManyObject:
    | TemplateStudioModel[typeof BUY_ONE_GET_MANY_OBJECT_PATH]
    | undefined = useWatch({
    control,
    name: BUY_ONE_GET_MANY_OBJECT_PATH
  });

  const designs = useMemo(() => {
    if (!buyOneGetManyObject) return [];
    return getBuyOneGetManyDesignsByFilter({
      desktopLayout: buyOneGetManyObject.desktopLayout,
      themes: buyOneGetManyObject.themes
    });
  }, [buyOneGetManyObject]);

  return (
    <>
      {designs.map((design) => (
        <DesignSidebarItem
          key={design.id}
          {...design}
          blockDesignIdPath="buyOneGetMany.selectedDesignId"
        />
      ))}
    </>
  );
};
